import {useNavigate, NavigateOptions} from 'react-router-dom';
import AnalyticsService from '@/services/analytics/AnalyticsService';
import getUrlWithBrandId from '@/utils/getUrlWithBrandId';

// TODO: make improvements
//  https://reactrouter.com/en/main/hooks/use-navigate
function useNavigation() {
  const navigateProxy = useNavigate();

  const navigate = async (
    to: string,
    params?: NavigateOptions | null,
    keepBrandIdIfPresent = true,
    openInNewTab = false
  ) => {
    let processedTo = to;
    if (keepBrandIdIfPresent) {
      processedTo = getUrlWithBrandId(to);
    }
    if (openInNewTab) {
      const redirectUrl = processedTo.startsWith('/')
        ? window.location.origin + processedTo
        : processedTo;
      window.open(redirectUrl, '_blank');
      return null;
    }

    const isExternalUrl = /^https?:\/\//i.test(processedTo);
    if (isExternalUrl && !processedTo.startsWith(window.location.origin)) {
      // Flush analytics events before navigating. This might cause a brief delay but
      // prevents losing events.
      try {
        await AnalyticsService.dischargeEventBatch();
      } catch (error) {
        // Silently handle analytics flush errors to avoid blocking navigation
      }
      window.location.href = processedTo;
      return null;
    }
    return navigateProxy(processedTo, params || undefined);
  };

  const goBack = () => {
    return navigateProxy(-1);
  };

  return {navigate, goBack};
}

export default useNavigation;
